{
   "app" : {
      "language_names" : {
         "english" : "English",
         "german" : "German"
      }
   },
   "credential" : {
      "credential_unavailable" : "This badge is unavailable, either because its already used or it has been removed",
      "device_unsupported" : "This device is not supported",
      "error_not_found" : "Badge not found",
      "error_not_found_description" : "Badge not found, please make sure you are using the correct link",
      "error_provider" : "Error provisioning credential",
      "error_provider_description" : "The credential provider reported an issue, please try again later.",
      "error_unknown" : "Unknown error occurred, if this error persists please contact support. Error code: {code}",
      "provider_redirect" : "Redirecting to provider...",
      "provider_unsupported" : "Provider not supported, please try refreshing this page",
      "sso_not_supported" : "This badge is not supported right now.",
      "title_android" : "Add your {name} badge to your Android device",
      "title_ipad" : "Adding your {name} badge to your iPad is not supported",
      "title_iphone" : "Add your {name} badge to your iPhone or Watch",
      "title_mfa" : "One-time password required",
      "title_other" : "To add your {name} badge, please scan the qr-code below on your mobile device",
      "title_unavailable" : "This credential is unavailable",
      "wallet_redirect" : "Redirecting to the wallet...",
      "warning" : "Be aware of your surroundings when using your badge, and shield it from view to prevent shoulder surfers from seeing your access information. By being mindful of your badge's security, you help protect yourself and the company."
   },
   "footer" : {
      "privacy_policy" : "Privacy policy"
   },
   "mfa" : {
      "btn_confirm" : "Confirm",
      "btn_request" : "Request",
      "btn_request_again" : "Request again",
      "btn_retry" : "Retry",
      "request_error" : "An error occurred while handling the one-time password.",
      "request_failed" : "Wrong one-time password.",
      "requested_both" : "An email and sms with the one-time password has been sent to {email} and {phone}",
      "requested_email" : "An email with the one-time password has been sent to {email}",
      "requested_phone" : "An sms with the one-time password has been sent to {phone}",
      "requested_unknown" : "The one-time password has been requested",
      "token_placeholder" : "000000"
   },
   "not_found" : {
      "message" : "Link is invalid, please make sure you are using the correct link."
   },
   "platform" : {
      "android" : {
         "start" : "Add to Google Wallet"
      },
      "desktop" : {
         "issue_with_credential_key" : "You cannot onboard this badge with a desktop browser, please open the link on your mobile device"
      },
      "ios" : {
         "start" : "Add to Apple Wallet"
      }
   }
}
